import React from 'react';
import { containerConnect } from '@configuratorware/configurator-frontendgui/Framework/ComponentContainer';
import { getConf, getComponent } from '@configuratorware/configurator-frontendgui/App/configuration';
import CallToAction from '@configuratorware/configurator-frontendgui/App/Shared/Components/CallToAction';
import memoize from '@configuratorware/configurator-frontendgui/Utils/Function/memoize';
import ProductPartsListContainer from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/ProductPartsList';
import { connect } from 'react-redux';
import DesignAreaControlbox from '@configuratorware/configurator-frontendgui/App/Modules/Designer/Containers/DesignAreaControlbox';
import withWidth from '@material-ui/core/withWidth/withWidth';
import ProductPartsList from '../../Components/ProductPartsList';
import { setCreatorMobileModalContent } from '../../../../Reducers/CustomCreatorReducer/Actions';

const removeHiddenComponents = memoize((components) => components.filter(({ hidden_in_frontend }) => !hidden_in_frontend));

const checkIfShowApply = (optionHasChanged) =>{if(!optionHasChanged) {return false;}
  return Object.keys(optionHasChanged).some((option) => optionHasChanged[option])};

const mapStateToProps = ({ configurator, customCreatorData, ui }) => ({
  Component: ProductPartsList,
  CallToActionComponent: getComponent('StartHere') || CallToAction,
  displaySwitchedOptions: getConf('displaySwitchedOptions'),
  optionclassifications: removeHiddenComponents(configurator.filteredOptionclassifications),
  selectedoptionclassification: configurator.selectedoptionclassification,
  showStartHere: false,
  vertical: false,
  doDisplayMobile: /* isMobileDevice() && */ customCreatorData.creatorMobileProductsListOpen,
  currentModalContentOption: customCreatorData.creatorMobileModalContent,
  modalContentOptions: customCreatorData.creatorMobileModalContentOptions,
  showMarker: !!ui.visibilityMap.optionlist,
  optionHasChanged: customCreatorData.creatorChangedClassifications,
  showApply: checkIfShowApply(customCreatorData.creatorChangedClassifications)
});
const mapDispatchToProps = (dispatch) => ({
  setModalContentOption: (value) => {
    dispatch(setCreatorMobileModalContent(value));
  },
});
export default containerConnect(mapStateToProps, mapDispatchToProps);
